import { ActivityPosition, POSITION_TOP } from 'global/constants';
import { canShowOptionLetter } from '../multiple-choice.utils';
import { MultipleChoiceOption } from '../multiple-choice.constants';
import { MultipleChoiceLetter } from '../multiple-choice';
import { MultipleChoiceButtonText } from '../multiple-choice-view.style';
import MultipleChoiceImagePrint from '../image/multiple-choice-image-print';
import * as Styled from './multiple-choice-text-image-print.style';

type Props = {
  optionMinHeight: number | null;
  imagePosition: ActivityPosition | null;
  showOptionLetter: boolean | null;
  option: MultipleChoiceOption;
  index: number;
  previewSize?: number;
};

const MultipleChoiceTextImagePrint = ({
  optionMinHeight,
  imagePosition,
  showOptionLetter,
  option,
  index,
  previewSize,
}: Props) => {
  return (
    <Styled.MultipleChoiceImageText
      $minHeight={optionMinHeight || 80}
      $imagePosition={imagePosition}
    >
      {imagePosition === POSITION_TOP && (
        <Styled.MultipleChoiceImageTextInner id="text-inner">
          <MultipleChoiceImagePrint option={option} previewSize={previewSize} />
        </Styled.MultipleChoiceImageTextInner>
      )}

      <Styled.MultipleChoiceImageTextColumn>
        {canShowOptionLetter(showOptionLetter) && (
          <MultipleChoiceLetter index={index} />
        )}
        <MultipleChoiceButtonText>{option.text}</MultipleChoiceButtonText>
      </Styled.MultipleChoiceImageTextColumn>

      {imagePosition !== POSITION_TOP && (
        <Styled.MultipleChoiceImageTextInner id="text-inner">
          <MultipleChoiceImagePrint option={option} previewSize={previewSize} />
        </Styled.MultipleChoiceImageTextInner>
      )}
    </Styled.MultipleChoiceImageText>
  );
};

export default MultipleChoiceTextImagePrint;
